import Vue from "vue";

Vue.filter(
  "toGBP",
  (value: any): string => {
    if (typeof value !== "number") {
      return value;
    }
    const formatter = new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP"
    });
    return formatter.format(value);
  }
);
